// extracted by mini-css-extract-plugin
module.exports = {"mysubtitle":"style_mysubtitle__2HYdf"};